import React, { useEffect, useState, useRef } from 'react';
const purchases = [{
  name: 'Lucas G.',
  city: 'Córdoba',
  initials: 'LG',
  product: 'Médico en Proceso™ — Nivel 1',
  time: 'hace 2 min'
}, {
  name: 'Sofía V.',
  city: 'Buenos Aires',
  initials: 'SV',
  product: 'Sistema Carrera Organizada™',
  time: 'hace 4 min'
}, {
  name: 'Martina P.',
  city: 'Rosario',
  initials: 'MP',
  product: 'Médico en Proceso™ — Nivel 1',
  time: 'hace 7 min'
}, {
  name: 'Agustín R.',
  city: 'Tucumán',
  initials: 'AR',
  product: 'Sistema de Gestión Académica™',
  time: 'hace 10 min'
}, {
  name: 'Valentina M.',
  city: 'Mendoza',
  initials: 'VM',
  product: 'Médico en Proceso™ — Nivel 1',
  time: 'hace 13 min'
}, {
  name: 'Ignacio H.',
  city: 'Santa Fe',
  initials: 'IH',
  product: 'Sistema Carrera Organizada™',
  time: 'hace 16 min'
}, {
  name: 'Camila B.',
  city: 'Salta',
  initials: 'CB',
  product: 'Médico en Proceso™ — Nivel 1',
  time: 'hace 19 min'
}, {
  name: 'Tomás F.',
  city: 'La Plata',
  initials: 'TF',
  product: 'Sistema de Gestión Académica™',
  time: 'hace 23 min'
}, {
  name: 'Lucía D.',
  city: 'Mar del Plata',
  initials: 'LD',
  product: 'Médico en Proceso™ — Nivel 1',
  time: 'hace 27 min'
}, {
  name: 'Mateo S.',
  city: 'San Juan',
  initials: 'MS',
  product: 'Sistema Carrera Organizada™',
  time: 'hace 31 min'
}, {
  name: 'Florencia N.',
  city: 'Neuquén',
  initials: 'FN',
  product: 'Médico en Proceso™ — Nivel 1',
  time: 'hace 35 min'
}, {
  name: 'Rodrigo E.',
  city: 'Paraná',
  initials: 'RE',
  product: 'Sistema de Gestión Académica™',
  time: 'hace 40 min'
}];
const avatarColors: Record<string, string> = {
  LG: '#0369a1',
  SV: '#7c3aed',
  MP: '#b45309',
  AR: '#065f46',
  VM: '#0e7490',
  IH: '#1d4ed8',
  CB: '#9f1239',
  TF: '#0369a1',
  LD: '#7c3aed',
  MS: '#065f46',
  FN: '#b45309',
  RE: '#1d4ed8'
};
const productEmoji: Record<string, string> = {
  'Médico en Proceso™ — Nivel 1': '✅',
  'Sistema Carrera Organizada™': '⭐',
  'Sistema de Gestión Académica™': '🏆'
};
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  const indexRef = useRef(0);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    function showNext() {
      setCurrent(indexRef.current);
      setVisible(true);
      timeoutRef.current = setTimeout(() => {
        setVisible(false);
        indexRef.current = (indexRef.current + 1) % purchases.length;
        const nextDelay = 12000 + Math.random() * 6000;
        timeoutRef.current = setTimeout(showNext, nextDelay);
      }, 4000);
    }
    timeoutRef.current = setTimeout(showNext, 8000);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  const purchase = current !== null ? purchases[current] : null;
  if (!purchase) return null;
  const bgColor = avatarColors[purchase.initials] || '#0284c7';
  const emoji = productEmoji[purchase.product] || '✅';
  return <div className="fixed bottom-4 left-4 z-50 max-w-[280px]" style={{
    animation: visible ? 'notifIn 0.3s ease-out forwards' : 'notifOut 0.3s ease-in forwards',
    pointerEvents: 'none'
  }} data-id="element-337">
      <div className="flex items-center gap-3 rounded-2xl px-4 py-3" style={{
      backgroundColor: 'rgb(255,255,255)',
      border: '1px solid rgba(14,165,233,0.25)',
      boxShadow: 'rgba(0,0,0,0.10) 0px 8px 24px 0px, rgba(14,165,233,0.08) 0px 0px 0px 1px'
    }} data-id="element-338">
        {/* Avatar */}
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-xs font-black text-white" style={{
        backgroundColor: bgColor
      }} data-id="element-339">
          {purchase.initials}
        </div>

        {/* Content */}
        <div className="min-w-0 flex-1" data-id="element-340">
          <p className="text-xs font-black text-gray-900 m-0 truncate" data-id="element-341">
            {purchase.name}
            <span className="font-normal text-gray-400" data-id="element-342">
              {' '}· {purchase.city}
            </span>
          </p>
          <p className="text-[11px] text-gray-600 m-0 truncate mt-0.5" data-id="element-343">
            {emoji} {purchase.product}
          </p>
          <div className="flex items-center gap-1 mt-1" data-id="element-344">
            <span className="inline-block w-1.5 h-1.5 rounded-full" style={{
            backgroundColor: '#0284c7'
          }} data-id="element-345" />
            <p className="text-[10px] font-bold m-0" style={{
            color: '#0284c7'
          }} data-id="element-346">
              Compra confirmada · {purchase.time}
            </p>
          </div>
        </div>
      </div>
    </div>;
}